/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { useCallback } from 'react';
import type { Command } from '../../common/types/commands/index.tsx';
import { useActionsCommandPalette } from '../command-palette/index.tsx';

/**
 * @deprecated if using in jira. Prefer:
 * import { useSubscribeCommands } from '@jira/compal__registry';
 */
export function useSubscribeCommandsWithRegistry<T extends string>(): (
	registrationId: T,
	commands: Command[],
) => () => void {
	const { addCommands, removeCommands, updateActiveRegistry, removeFromActiveRegistry } =
		useActionsCommandPalette();

	const subscribe = useCallback(
		(registrationId: T, commands: Command[]) => {
			updateActiveRegistry(registrationId, commands);
			addCommands(commands);
			return () => {
				removeCommands(commands);
				removeFromActiveRegistry(registrationId, commands);
			};
		},
		[addCommands, removeCommands, removeFromActiveRegistry, updateActiveRegistry],
	);

	return subscribe;
}
